import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const VideoPop = ({ videoUrl, onClose }) => {
  
    const styles = {
      overlay: {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
      },
      video: {
        maxWidth: "90vw",
        maxHeight: "90vh",
        outline: "none"
      },
      videoContainer: {
        position: "relative",
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      blackBars: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "black"
      },
      closeButton: {
        position: "absolute",
        top: 15,
        right: 25,
        fontSize: 40,
        cursor: "pointer",
        color: "white"
      }
    };
    
    // Media queries for smaller screens
    const mediaQueries = {
      smallScreen: {
        video: {
          maxWidth: "80vw",
          maxHeight: "80vh",
        }
      },
      tinyScreen: {
        video: {
          maxWidth: "70vw",
          maxHeight: "70vh",
        }
      }
    };

    const [mq, setMq] = useState('normal');

    useEffect(() => {
      const smallScreen = window.matchMedia('(max-width: 768px)');
      const tinyScreen = window.matchMedia('(max-width: 576px)');
  
      if (smallScreen.matches) {
        setMq('smallScreen');
      } else if (tinyScreen.matches) {
        setMq('tinyScreen');
      } else {
        setMq('normal');
      }
  
      smallScreen.addEventListener('change', (e) => {
        if (e.matches) {
          setMq('smallScreen');
        } else {
          setMq('normal');
        }
      });
  
      tinyScreen.addEventListener('change', (e) => {
        if (e.matches) {
          setMq('tinyScreen');
        } else if (smallScreen.matches) {
          setMq('smallScreen');
        } else {
          setMq('normal');
        }
      });
  
      return () => {
        smallScreen.removeEventListener('change', () => {});
        tinyScreen.removeEventListener('change', () => {});
      };
    }, []);


    const handleKeyDown = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
  
    useEffect(() => {
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [onClose]);
  
    return (
      <div style={styles.overlay}>
        <div style={styles.videoContainer}>
          <div style={styles.blackBars} />
          <video
            style={{ ...styles.video, ...(mediaQueries[mq]?.video || {}) }}
            controls
            autoPlay
            // onEnded={() => onClose()}
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
          <div style={styles.closeButton} onClick={() => onClose()}>
            &times;
          </div>
        </div>
      </div>
    );
  };
  
  export default VideoPop;